import { AdbPacket, AdbPacketSerializeStream } from "@yume-chan/adb";
import { StructDeserializeStream, WrapReadableStream, WrapWritableStream, pipeFrom, } from "@yume-chan/stream-extra";
export default class AdbDirectSocketsBackend {
    static isSupported() {
        return (typeof window !== "undefined" && !!window.navigator?.openTCPSocket);
    }
    serial;
    host;
    port;
    name;
    constructor(host, port = 5555, name) {
        this.host = host;
        this.port = port;
        this.serial = `${host}:${port}`;
        this.name = name;
    }
    async connect() {
        const { readable, writable } = await navigator.openTCPSocket({
            remoteAddress: this.host,
            remotePort: this.port,
            noDelay: true,
        });
        // Native streams can't `pipeTo()` or `pipeThrough()` polyfilled streams, so we need to wrap them
        return {
            readable: new WrapReadableStream(readable).pipeThrough(new StructDeserializeStream(AdbPacket)),
            writable: pipeFrom(new WrapWritableStream(writable), new AdbPacketSerializeStream()),
        };
    }
}
//# sourceMappingURL=index.js.map